export const normalizeTownFromLookup = (value: unknown): string => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return trimmed.toLowerCase() === "na" ? "na" : trimmed;
};

export const hasInvalidPartyLocationValue = (value: unknown): boolean => {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  if (normalized === "na") return false;
  return (
    normalized === "" ||
    ["n/a", "not available", "null"].includes(normalized)
  );
};

export const getCountryCodeFromState = (value: unknown): string => {
  if (typeof value !== "string") return "";
  const normalized = value.trim().toUpperCase();
  const match = normalized.match(/^([A-Z]{2})(?:-[A-Z0-9]{1,3})?$/);
  return match?.[1] || "";
};

export const filterCountryOptionsByState = <T extends { value?: unknown }>(
  options: T[],
  stateCountryCode: unknown
): T[] => {
  const countryCode = getCountryCodeFromState(stateCountryCode);
  if (!countryCode) return options;
  return options.filter(
    (option) =>
      typeof option?.value === "string" &&
      option.value.trim().toUpperCase() === countryCode
  );
};

export const unwrapScSearchItems = (payload: any): any[] => {
  let value = payload?.response ?? payload;
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return [];
    }
  }
  if (value?.response !== undefined) return unwrapScSearchItems(value.response);
  return Array.isArray(value) ? value : [];
};
